import { render, staticRenderFns } from "./EditorTable.vue?vue&type=template&id=4d994ae6&scoped=true&"
import script from "./EditorTable.vue?vue&type=script&lang=js&"
export * from "./EditorTable.vue?vue&type=script&lang=js&"
import style0 from "./EditorTable.vue?vue&type=style&index=0&id=4d994ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d994ae6",
  null
  
)

export default component.exports